module.exports = {"610632001":"桥山街道","610632101":"店头镇","610632102":"隆坊镇","610632103":"田庄镇","610632104":"阿党镇","610632105":"双龙镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/610632.json
// module id = 2637
// module chunks = 0